import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import {
  ComboBoxModule,
  DropDownListModule,
  MultiSelectModule,
} from '@syncfusion/ej2-angular-dropdowns';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteControl } from './controls/autocomplete/autocomplete.control';
import { CheckboxControl } from './controls/checkbox/checkbox.control';
import { ComboBoxControl } from './controls/combo-box/combo-box.control';
import { ControlTemplate } from './controls/control.template';
import { DropDownListControl } from './controls/drop-down-list/_index';
import { MultiSelectControl } from './controls/multi-select/_index';
import { PasswordControl } from './controls/password/password.control';
import { PrimengTextInputControl } from './controls/primeng-text-input/primeng-text-input.control';
import { SelectControl } from './controls/select/select.control';
import { TextAreaControl } from './controls/text-area/text-area.control';
import { TextInputControl } from './controls/text-input/text-input.control';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // There still seems to be an issue with the SeahorseTranslateModule breaking the translation.
    // Using TranslateModule for now
    // SeahorseTranslateModule.forChild('assets/forms/i18n'),
    TranslateModule,
    // PrimeNg
    AutoCompleteModule,
    DropdownModule,
    InputTextModule,
    // SyncFusion
    TextBoxModule,
    DropDownListModule,
    CheckBoxModule,
    MultiSelectModule,
    ComboBoxModule,
    ControlTemplate,
  ],
  declarations: [
    AutoCompleteControl,
    CheckboxControl,
    ComboBoxControl,
    DropDownListControl,
    MultiSelectControl,
    PasswordControl,
    PrimengTextInputControl,
    SelectControl,
    TextAreaControl,
    TextInputControl,
  ],
  exports: [
    AutoCompleteControl,
    CheckboxControl,
    ComboBoxControl,
    DropDownListControl,
    MultiSelectControl,
    PasswordControl,
    PrimengTextInputControl,
    SelectControl,
    TextAreaControl,
    TextInputControl,
  ],
})
export class SeahorseFormsModule {}
